import React, { useState } from 'react';
import logo from '../assets/logo.png'; 
import { GiHamburgerMenu } from "react-icons/gi";
import { GrClose } from "react-icons/gr"; // Import close icon
import { Link, useNavigate } from 'react-router-dom';
import useToken from '../context/useToken';

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false); // State to track menu open/close
  const navigate = useNavigate();
  const token = useToken();

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const handleLogout = () => {
    // Remove the token from local storage
    localStorage.removeItem('token');
    
    // Navigate to the new route and reload the page
    navigate('/');
    window.location.reload();
  };
  

  const handleMenuItemClick = () => {
    setMenuOpen(false); // Close the menu when a mobile menu item is clicked
  };

  return (
    <header className="absolute mt-5 top-0 left-0 right-0 flex items-center md:flex-row justify-between px-10 py-8 z-10 bg-transparent">
      {/* Logo */}
      <Link to='/'>
      <div className="flex items-center">
        <img src={logo} alt="Trydo Logo" className="h-[4.5rem] mr-3" /> 
      </div>
      </Link>
      {/* Hamburger Icon (visible on smaller screens only) */}
      <div onClick={toggleMenu} className="cursor-pointer md:hidden">
        {menuOpen ? <GrClose className="text-black text-3xl" /> : <GiHamburgerMenu className="text-[#c6c9d8] text-3xl" />}
      </div>
      {/* Navigation Items (visible on larger screens) */}
      <div className={`hidden md:flex items-center space-x-16`}>
        <nav className="flex space-x-8">
          <Link to="/" className="text-[#c6c9d8] font-medium text-[16px] transition-colors duration-300 hover:text-[#25a182]">Home</Link>
          <Link to="/about" className="text-[#c6c9d8] font-medium text-[16px] transition-colors duration-300 hover:text-[#25a182]">About Us</Link>
          <Link to="/franchise" className="text-[#c6c9d8] font-medium text-[16px] transition-colors duration-300 hover:text-[#25a182]">Franchise Development</Link>
          <Link to="/advisory" className="text-[#c6c9d8] font-medium text-[16px] transition-colors duration-300 hover:text-[#25a182]">Advisory Services</Link>
          <Link to="/brand" className="text-[#c6c9d8] font-medium text-[16px] transition-colors duration-300 hover:text-[#25a182]">Brand Solutions</Link>
          <Link to="/experiential" className="text-[#c6c9d8] font-medium text-[16px] transition-colors duration-300 hover:text-[#25a182]">Experiential Marketing</Link>
          {/* <Link to="/client" className="text-[#c6c9d8] font-medium text-[16px] transition-colors duration-300 hover:text-[#25a182]">Client Portfolio</Link> */}
          {/* <Link to="/partners" className="text-[#c6c9d8] font-medium text-[16px] transition-colors duration-300 hover:text-[#25a182]">Our Partners</Link> */}
          {/* <Link to="/ourservices" className="text-[#c6c9d8] font-medium text-[16px] transition-colors duration-300 hover:text-[#25a182]">Our Services</Link> */}
          <Link to="/contact" className="text-[#c6c9d8] font-medium text-[16px] transition-colors duration-300 hover:text-[#25a182]">Contact Us</Link>
          {token && <button
          onClick={handleLogout}
              className="bg-red-500 text-white font-medium text-[16px] border border-red-600 rounded transition-all duration-300 hover:bg-red-600 hover:border-red-700 hover:text-white"
            >
              Log Out
            </button>}
        </nav>

      </div>
      {/* Mobile Menu */}
      <div className={`fixed top-0 right-0 z-100 bg-white w-[70%] h-screen transition-transform duration-300 ${menuOpen ? 'translate-x-0' : 'translate-x-full'} md:hidden`}>
        <div className="flex relative top-12 mb-2 right-7 justify-end p-4">
          <div onClick={toggleMenu} className="cursor-pointer">
            <GrClose className="text-black text-3xl" />
          </div>
        </div>
        <nav className="flex flex-col items-start p-8 space-y-4">
          <Link to="/" onClick={handleMenuItemClick} className="text-[#1f1f25] font-medium text-[16px] transition-colors duration-300 hover:text-[#25a182]">Home</Link>
          <Link to="/about" onClick={handleMenuItemClick} className="text-[#1f1f25] font-medium text-[16px] transition-colors duration-300 hover:text-[#25a182]">About Us</Link>
          <Link to="/franchise" onClick={handleMenuItemClick} className="text-[#1f1f25] font-medium text-[16px] transition-colors duration-300 hover:text-[#25a182]">Franchise Development</Link>
          <Link to="/advisory" onClick={handleMenuItemClick} className="text-[#1f1f25] font-medium text-[16px] transition-colors duration-300 hover:text-[#25a182]">Advisory Services</Link>
          <Link to="/brand" onClick={handleMenuItemClick} className="text-[#1f1f25] font-medium text-[16px] transition-colors duration-300 hover:text-[#25a182]">Brand Solutions</Link>
          <Link to="/experiential" onClick={handleMenuItemClick} className="text-[#1f1f25] font-medium text-[16px] transition-colors duration-300 hover:text-[#25a182]">Experiential Marketing</Link>
          {/* <Link to="/client" onClick={handleMenuItemClick} className="text-[#1f1f25] font-medium text-[16px] transition-colors duration-300 hover:text-[#25a182]">Client Portfolio</Link> */}
          {/* <Link to="/partners" onClick={handleMenuItemClick} className="text-[#1f1f25] font-medium text-[16px] transition-colors duration-300 hover:text-[#25a182]">Our Partners</Link> */}
          {/* <Link to="/ourservices" onClick={handleMenuItemClick} className="text-[#1f1f25] font-medium text-[16px] transition-colors duration-300 hover:text-[#25a182]">Our Services</Link> */}
          <Link to="/contact" onClick={handleMenuItemClick} className="text-[#1f1f25] font-medium text-[16px] transition-colors duration-300 hover:text-[#25a182]">Contact Us</Link>
          {token && <button
          onClick={handleLogout}
              className="bg-red-500 text-white font-medium text-[16px] border border-red-600 rounded transition-all duration-300 hover:bg-red-600 hover:border-red-700 hover:text-white"
            >
              Log Out
            </button>}
        </nav>
      </div>
    </header>
  );
};

export default Header;
